

import { Button, Col, Form, Input, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { FileExcelOutlined, FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';

import './AccountsFilterComponent.scss'
import { AccountFilter } from '../../../models/AccountsFilter';
import CommissionExportModal from '../export/CommissionExportModal';

interface AccountsFilterComponentProps {
    onSearch: (filterData: AccountFilter) => void;
    actualFilter : AccountFilter ; 
    searching: boolean;
}

const AccountsFilterComponent = (props: AccountsFilterComponentProps) : JSX.Element => {
    
    const { t } = useTranslation();

    const { searching } = props;

    const [form] = Form.useForm();

    const [exportModalVisible, setExportModalVisible] = useState<boolean>(false);
    const [exportFilter, setExportFilter] = useState<AccountFilter>(props.actualFilter);

    useEffect(() => {
        form.setFieldsValue({ name: props.actualFilter.name });
    }, [props.actualFilter.name]);

    const onFinish = (values: any) => {
        props.onSearch({
            name: values.name,
            email: values.email,
            status: values.status,
            location: values.location,
            accountType: values.accountType,
            page: props.actualFilter.page,
            pageSize: props.actualFilter.pageSize,
        });
    }

    const showExportModal = () => {
        const values = form.getFieldsValue();

        setExportFilter({
            name: values.name,
            email: values.email,
            status: values.status,
            location: values.location,
            accountType: values.accountType,
            page: props.actualFilter.page,
            pageSize: props.actualFilter.pageSize,
        });
        setExportModalVisible(true);
    };

    return(
        <div className="accounts-filter">

            {/* ── Cabecera ───────────────────────────────────────────── */}
            <div className="filter-header">
                <span className="filter-title">
                    <FilterOutlined /> {t("components.accounts.filter.buscador")}
                </span>
                <Button className="export-button" onClick={showExportModal}>
                    <FileExcelOutlined className="excel-button" /> {t("components.accounts.filter.export-data")}
                </Button>
            </div>

            {/* ── Formulario ─────────────────────────────────────────── */}
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Row gutter={16}>
                    <Col xs={24} sm={12} md={5}>
                        <Form.Item name="name" label={t("components.accounts.filter.name")} initialValue={''}>
                            <Input className="app-input" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={5}>
                        <Form.Item name="email" label={t("components.accounts.filter.email")} initialValue={''}>
                            <Input className="app-input" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={4}>
                        <Form.Item name="status" label={t("components.accounts.filter.status")} initialValue={''}>
                            <Select className="app-input" allowClear>
                                <Select.Option value="">{t("forms.selects.select-else")}</Select.Option>
                                <Select.Option value="active">{t("components.accounts.filter.status-active")}</Select.Option>
                                <Select.Option value="inactive">{t("components.accounts.filter.status-inactive")}</Select.Option>
                                <Select.Option value="validation_needed">{t("components.accounts.filter.status-validation-needed")}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={4}>
                        <Form.Item name="location" label={t("components.accounts.filter.location")} initialValue={''}>
                            <Input className="app-input" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={4}>
                        <Form.Item name="accountType" label={t("components.accounts.filter.account-type")} initialValue={''}>
                            <Select className="app-input" allowClear>
                                <Select.Option value="">{t("forms.selects.select-else")}</Select.Option>
                                <Select.Option value="agency_agent">{t("components.accounts.filter.agency")}</Select.Option>
                                <Select.Option value="corporate_agent">{t("components.accounts.filter.business")}</Select.Option>
                                <Select.Option value="independent">{t("components.accounts.filter.independent")}</Select.Option>
                                <Select.Option value="event_organizer">{t("components.accounts.filter.events")}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={2}>
                        <Form.Item label=" ">
                            <Button
                                className="search-btn"
                                htmlType="submit"
                                disabled={searching}
                                loading={searching}
                                icon={<SearchOutlined />}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            {exportModalVisible &&
                <CommissionExportModal
                    visible={exportModalVisible}
                    filter={exportFilter}
                    onCancel={() => setExportModalVisible(false)}
                />
            }
        </div>
    )
}

export default AccountsFilterComponent;
